@if (stage().stage; as stage) {
  <span class="stage-name">{{ stage.name }}</span>
}

<div class="reviewers">
  @for (evaluation of stage().reviewers; track evaluation.resultId) {
    <rt-candidate-offer-evaluation-reviewer-result
      [evaluation]="evaluation"
      [theme]="theme()"
      [useProsemirror]="useProsemirror()"
      (edit)="edit.emit($event)"
      (delete)="delete.emit($event)"
    />
  }
</div>
